import { render, staticRenderFns } from "./OneReport.vue?vue&type=template&id=1ead52aa&scoped=true&"
import script from "./OneReport.vue?vue&type=script&lang=js&"
export * from "./OneReport.vue?vue&type=script&lang=js&"
import style0 from "./OneReport.vue?vue&type=style&index=0&id=1ead52aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead52aa",
  null
  
)

export default component.exports